import { render, staticRenderFns } from "./VipLevel.vue?vue&type=template&id=0b961de8&scoped=true"
import script from "./VipLevel.vue?vue&type=script&lang=js"
export * from "./VipLevel.vue?vue&type=script&lang=js"
import style0 from "./VipLevel.vue?vue&type=style&index=0&id=0b961de8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b961de8",
  null
  
)

export default component.exports